<template>
  <div style="margin: 0 0 12px;">
    <el-input type="textarea" :rows="4" v-model="remark" :placeholder="state == 2?'请输入审核不通过的具体原因：':'请输入审核通过的具体原因：'" style="width: 100%; flex: 1"/>
    <div class="dialog-footer" style="text-align: center; margin-top: 8px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import {updateStockTakeCommodityState} from "@/api/url";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      state: this.value.state,
      idArr: this.value.idArr,

      remark: '',

    }
  },
  methods: {



    cancel() {
      this.$emit("close");
    },
    summit() {
      let param = {}
      param['idArr'] = this.idArr
      param['state'] = this.state
      param['remark'] = this.remark
      postFormData(updateStockTakeCommodityState, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },





  },
  mounted() {
  }
}
</script>

<style scoped>

</style>
